export default __webpack_public_path__ + "static/media/CharisSIL-B.7b294c07.ttf";